var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.type === 'brain')?_c('lottie',{attrs:{"options":_vm.defaultOptions,"height":340,"width":260},on:{"animCreated":_vm.handleAnimation}}):(_vm.type === 'circle')?_c('div',{class:`bg-loader ${this.dark && 'bg-loader--dark'} ${this.contentLoader &&
        'bg-loader--content'}`}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }